import { Button } from '@cibli/shared';
import { FileText } from 'lucide-react';

type CVListEmptyProps = {
  title: string;
  description: string;
  ctaLabel: string;
  onCreate: () => void;
};

export default function CVListEmpty({ title, description, ctaLabel, onCreate }: CVListEmptyProps) {
  return (
    <div className="text-center py-16">
      <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
        <FileText className="w-8 h-8 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-medium text-foreground mb-2">{title}</h3>
      <p className="text-muted-foreground mb-6">{description}</p>
      <Button onClick={onCreate}>
        <span className="mr-2">✨</span>
        {ctaLabel}
      </Button>
    </div>
  );
}
